/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect } from "react";
import SelectFieldComboInput from "module/components/form/inputs/select-field-combo/select-field-combo-input";
import { endsWith, map, isEmpty } from "ramda";
import withSizeWindow from "application/hoc/with-size-window";
import { useState } from "react";

const SelectFieldComboField = (props) => {
  const {
    register,
    size,
    setSelectValue,
    path,
    name,
    selOptions,
    multiple,
    defaultValue,
    errors,
    isHidden,
    hasSearch,
    hasPriceDiscount,
  } = props;

  const [toggle, setToggle] = useState(true);

  useEffect(() => {
    if (!isEmpty(path) && endsWith("arrangement_group.arrangement", path)) {
      setSelectValue(`${path}.value`, []);
      setToggle(!toggle);
    }
  }, [selOptions]);

  const getAuxiliarInputs = (option) => {
    return (
      <div style={{ display: "none" }} key={`aux-${option.key}`}>
        <label>
          <input type="checkbox" name={`${path}.value`} ref={register} value={option.key} />
          <span>{option.key}</span>
        </label>
      </div>
    );
  };

  const getOption = (option) => {
    return { value: option.key, label: option.value };
  };

  const onChange = (value, label) => {
    const isColor = path.toLowerCase().includes("color");
    setSelectValue(`${path}.value`, value);
    if (isColor) {
      const optionToSelect = selOptions.find((option) => option.key === value[0]);
      const pathColor = path.replace("color_dropdown", "color");
      setSelectValue(`${pathColor}.value`, optionToSelect ? optionToSelect.value : null);
    }
    const isProvince = path.toLowerCase().includes("province");
    if (isProvince) {
      setSelectValue("province.value", label);
      setSelectValue("province_code.value", value);
    }
  };

  const findLabelByValue = (options, valueToFind) => {
    const province = options.find((province) => province.key === valueToFind[0]);
    return province ? province.value : null;
  };

  const onChangeMulti = (value) => {
    setSelectValue(`${path}.value`, value);
  };

  return (
    <Fragment>
      {map((option) => getAuxiliarInputs(option), selOptions)}
      <SelectFieldComboInput
        name={name}
        path={path}
        isMulti={multiple}
        options={map((option) => getOption(option), selOptions)}
        onChange={(value, label) => onChange(value, findLabelByValue(selOptions, value))}
        onChangeMulti={(value) => onChangeMulti(value)}
        size={size}
        defaultValue={defaultValue}
        errors={errors}
        toggle={toggle}
        isHidden={isHidden}
        hasSearch={hasSearch}
        hasPriceDiscount={hasPriceDiscount}
      />
    </Fragment>
  );
};

export default withSizeWindow(SelectFieldComboField);
